import { Delete16 } from 'ui/icons/aurora/16px/Delete16';
import { ButtonProps } from 'modules/queryBuilder/contexts';
import { useTranslation } from 'modules/queryBuilder/hooks/useTranslation';
import { QueryBuilderIconButton } from './QueryBuilderIconButton';

export const DATA_TEST = {
  button: 'remove-criteria-button',
};

export const RemoveCriteriaButton = (props: ButtonProps) => {
  const { t } = useTranslation();
  return (
    <QueryBuilderIconButton
      {...props}
      dataTest={DATA_TEST.button}
      tooltipContent={t('storybook.buttons.tooltips.remove')}
      Icon={Delete16}
    />
  );
};
